
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/migration-guide/implementing-hightouch-events",
      function () {
        return require("private-next-pages/events/migration-guide/implementing-hightouch-events.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/migration-guide/implementing-hightouch-events"])
      });
    }
  